"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bar_1 = require("@nivo/bar");
const chart_style_1 = __importDefault(require("../chart.style"));
const time_handler_1 = require("utils/time-handler");
const BarChart = ({ data, ariaLabel, appTheme }) => {
    return ((0, jsx_runtime_1.jsx)(bar_1.ResponsiveBar, { data: data, indexBy: 'silo', keys: ['Actual', 'Target'], label: d => (0, time_handler_1.minutesToString)(d.value), valueFormat: value => (0, time_handler_1.minutesToString)(value), margin: { top: 0, right: 130, bottom: 50, left: 60 }, padding: 0.3, innerPadding: 8, groupMode: 'grouped', layout: 'horizontal', valueScale: { type: 'linear' }, indexScale: { type: 'band', round: true }, colors: { scheme: 'set1' }, borderRadius: 4, borderColor: {
            from: 'color',
            modifiers: [
                [
                    'darker',
                    1.6
                ]
            ]
        }, axisTop: null, axisRight: null, axisBottom: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: '',
            legendPosition: 'middle',
            legendOffset: 32
        }, axisLeft: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: '',
            legendPosition: 'middle',
            legendOffset: -40
        }, labelSkipWidth: 12, labelSkipHeight: 12, labelTextColor: {
            from: 'color',
            modifiers: [
                [
                    'darker',
                    1.6
                ]
            ]
        }, theme: chart_style_1.default.LineChartStyle(appTheme), legends: [
            {
                dataFrom: 'keys',
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ], role: 'application', ariaLabel: ariaLabel, barAriaLabel: function (e) { return e.id + ': ' + e.formattedValue + ' in silo: ' + e.indexValue; } }));
};
exports.default = BarChart;
